import { ImageElement } from "./PdfElements";

export const ImageElementRender = ({ element }: { element: ImageElement }) => {
    return <img className="pointer-events-none w-full h-full object-fill object-center" src={element.value} alt="" />;
};
